import { createContext } from "react";

const ArtworkProjectionContext = createContext();

export default ArtworkProjectionContext;
